import { graphql } from 'gatsby';
import { ComponentReviewsCards } from './ComponentReviewsCards';
import { ComponentReviewsSpotlight } from './ComponentReviewsSpotlight';

import type { ContentBlock } from '~components/types';
import type { ComponentReviewsProps } from './types';

export const ComponentReviews: ContentBlock<ComponentReviewsProps> = (props) => {
  switch (props.content.display) {
    case 'cards':
      return <ComponentReviewsCards {...props} />;
    case 'spotlight':
    default:
      return <ComponentReviewsSpotlight {...props} />;
  }
};

export const reviewsQuery = graphql`
  fragment ComponentReviews on ContentfulComponentReviews {
    __typename
    heading
    items {
      ...ComponentReviewItem
    }
    carouselInterval
    display
    theme
  }
`;

export const reviewItemQuery = graphql`
  fragment ComponentReviewItem on ContentfulComponentReviewItem {
    __typename
    author
    label
    content {
      content
    }
    authorPhoto {
      ...MixedMedia
    }
    image {
      ...MixedMedia
    }
    imagePosition
    occupation
  }
`;
